<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Meu Perfil</div>
            </div>
            <div class="card-body">
              <div class="form-group">
                <img
                  v-if="previewImage"
                  :src="previewImage"
                  style="card-body"
                  class="photo"
                />
                <img
                  v-else
                  :src="users.photo"
                  style="card-body"
                  class="photo"
                />
              </div>
              <div class="profile_user form-group">
                <h3 class="user_name_max">{{ users.name }}</h3>
                <hr class="hr" />
                <p style="text-align: center">{{ users.email }}</p>
                <br />
                <br />
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="userName">
                          <span class="required">*</span> Nome:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.name"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">
                          <span class="required">*</span> Email:
                        </label>
                        <input
                          disabled
                          autocomplete="off"
                          class="form-control"
                          id="userEmail"
                          placeholder=""
                          type="text"
                          v-model="users.email"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="userCellphone">
                          <span class="required">*</span> Celular:
                        </label>
                        <input
                          class="form-control"
                          type="text"
                          v-mask="'(##) 99999-9999'"
                          v-model="users.cellphone"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="userPhone">Telefone:</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.telphone"
                          v-mask="'(##) 9999-9999'"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputZipcode">
                          <span class="required">*</span> CEP:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.cep"
                          placeholder=""
                          v-mask="'99999-999'"
                          @keyup="buscar()"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="userAddress">
                          <span class="required">*</span> Logradouro:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.street"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="inputNeighborhood">
                          <span class="required">*</span> Bairro:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.neighborhood"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputNumber">
                          <span class="required">*</span> Número:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.number"
                          placeholder=""
                          id="inputNumero"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputComplement">Complemento:</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.complement"
                          placeholder=""
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputCity">
                          <span class="required">*</span> Cidade:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.city"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputState">
                          <span class="required">*</span> Estado:
                        </label>
                        <input
                          type="text"
                          maxlength="2"
                          class="form-control"
                          v-model="users.state"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputCompany">
                          <span class="required">*</span> Empresa:
                        </label>
                        <select
                          v-model="users.company_id"
                          class="form-control"
                          disabled
                        >
                          <option
                            v-for="company in companies"
                            :value="company.id"
                            :key="company.id"
                          >
                            {{ company.company_name_fantasy }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputDepartment">
                          <span class="required">*</span> Departamento:
                        </label>
                        <select
                          v-model="users.department_id"
                          class="form-control"
                          disabled
                        >
                          <option
                            v-for="department in departments"
                            :value="department.id"
                            :key="department.id"
                          >
                            {{ department.description }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <div>
                        <b-button v-b-modal.modal-1 variant="btn btn-add"
                          >Deseja alterar a senha?</b-button
                        >
                      </div>

                      <b-modal id="modal-1" hide-footer="true">
                        <div class="modal-header">
                          <label class="form-control"
                            >Digite a nova Senha</label
                          >
                        </div>
                        <div class="modal-body">
                          <div class="col-md-12">
                            <div class="panel panel-default">
                              <div class="panel-body">
                                <div class="text-center">
                                  <div class="panel-body">
                                    <fieldset>
                                      <div class="form-group">
                                        <label for="userPassword">
                                          <span class="required">*</span>
                                          Nova Senha:
                                        </label>
                                        <input
                                          type="password"
                                          class="form-control"
                                          id="userPassword"
                                          v-on:keyup="keymonitor"
                                          v-model="users.new_password"
                                          autocomplete="false"
                                          minlength="6"
                                          maxlength="12"
                                        />
                                      </div>
                                      <div class="form-group">
                                        <label for="userPasswordConfirmation">
                                          <span class="required">*</span>
                                          Confirmar Senha:
                                        </label>
                                        <input
                                          type="password"
                                          v-on:keyup="keymonitor"
                                          class="form-control"
                                          id="userPasswordConfirmation"
                                          v-model="users.password_confirmation"
                                          placeholder
                                          autocomplete="false"
                                          minlength="6"
                                          maxlength="12"
                                        />
                                      </div>
                                      <div
                                        v-if="comparePassword()"
                                        class="left"
                                      >
                                        <label>
                                          <div
                                            class="alert alert-danger col-md-12"
                                            role="alert"
                                          >
                                            <span class="comparePassword"
                                              >As senhas não podem ser
                                              diferentes!</span
                                            >
                                          </div>
                                        </label>
                                      </div>
                                      <div class="left">
                                        <label v-if="activatedCaps">
                                          <span class="caps">
                                            CapsLock Ativo
                                            <i
                                              class="fa fa-arrow-circle-up"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                        </label>
                                      </div>
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <div class="col-md-12">
                            <div class="block text-right">
                              <b-button
                                type="button"
                                variant="btn btn-add"
                                @click="hideModal"
                              >
                                <i class="fa fa-save"></i> Salvar
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </b-modal>
                    </div>
                    <hr />

                    <div class="form-group">
                      <label for="userPic">Foto do Perfil</label>
                      <input
                        type="file"
                        class="form-control"
                        id="userPic"
                        accept="image/*"
                        name="userPic"
                        @change="uploadImage"
                        placeholder
                      />
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import vSelect from "vue-select";
import CtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  name: "imageUpload",
  data() {
    return {
      users: {
        name: "",
        email: "",
        cellphone: "",
        telphone: "",
        photo: "",
        cep: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
        access_nivel: "",
        company_id: "",
        department_id: "",
        new_password: "",
        password_confirmation: "",
      },
      departments: [],
      companies: [],
      endereco: {},
      activatedCaps: false,

      errors: undefined,

      previewImage: null,
    };
  },
  computed: {},
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("userPic");

      fd.append("name", self.users.name);
      fd.append("email", self.users.email);
      fd.append("cellphone", self.users.cellphone);
      fd.append("telphone", self.users.telphone);

      fd.append("street", self.users.street);
      fd.append("neighborhood", self.users.neighborhood);
      // fd.append("complement", self.users.complement ? self.users.complement : "");
      fd.append("complement", self.users.complement);
      fd.append("number", self.users.number);
      fd.append("city", self.users.city);
      fd.append("state", self.users.state);
      fd.append("cep", self.users.cep);

      fd.append("company_id", self.users.company_id);
      fd.append("department_id", self.users.department_id);
      fd.append("access_nivel", self.users.access_nivel);
      fd.append("password", self.users.new_password);
      fd.append("password_confirmation", self.users.password_confirmation);

      fd.append("_method", "POST");

      fd.append("photo", photo.files[0] ? photo.files[0] : "");

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "users";

      let fd = self.makeFormData();

      if (self.users.id) {
        api += "/" + self.users.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    comparePassword: function () {
      if (this.users.new_password != this.users.password_confirmation || null)
        return [];
    },
    keymonitor() {
      if (event.getModifierState && event.getModifierState("CapsLock")) {
        this.activatedCaps = true;
      } else {
        this.activatedCaps = false;
      }
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.users.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.users.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.users.street = self.endereco.logradouro;
            self.users.neighborhood = self.endereco.bairro;
            self.users.state = self.endereco.uf;
            self.users.city = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    clearModal() {
      this.users.password_confirmation = "";
      this.users.new_password = "";
    },
    hideModal() {
      this.$bvModal.hide("modal-1");
    },
    // getAcceptTerms: function () {
    //   this.url = this.$route.params.accept_terms;

    //   console.log(this.url);
    // },

    getUsers: function (id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDepartments: function (id) {
      const self = this;
      const api = self.$store.state.api + "departments/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
  },
  mounted: function () {
    const self = this;

    self.getDepartments();
    self.getCompanies();
    let id = self.$store.getters.user.id;
    if (id) {
      self.getUsers(id);
    }
  },
  components: {
    BaseCrud,
    CtkDateTimePicker,
    vSelect,
  },
};
</script>
<style scoped>
.left {
  text-align: left;
}
.photo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.modal-footer {
  border-top: 0px;
}
.pointer {
  cursor: pointer;
}
.caps {
  color: black;
  font: bold;
  text-align: right;
  font-size: 20px;
}

.required {
  color: red !important;
}
.btn-put-prof:hover,
.btn-put-prof[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.profile_user {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Auth/Profile.vue